import * as React from 'react';
import { Redirect, useRouteMatch } from 'react-router-dom';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { SettingsHome } from '../../components/SettingsHome';
import { canOpenSetting, SettingsCardType } from '../../models/setting';
import { ReportingContainer } from '../Reporting';
import { AgentTemplates } from './AgentTemplates';
import { Blitzes } from './Blitzes';
import { CallAnalysis } from './CallAnalysis';
import { Categories } from './Categories';
import { Gamification } from './Gamification';
import { Goals } from './Goals';
import { IssuesLog } from './IssuesLog';
import { PhoneNumbers } from './PhoneNumbers';
import { PrizesLog } from './PrizesLog';
import { ScenarioManagement } from './ScenarioManagement';
import { SlotMachinePrizes } from './SlotMachinePrizes';
import { SlotMachines } from './SlotMachines';
import { StartABlitz } from './StartABlitz';
import { Utilities } from './Utilities';

const SettingPages: Partial<Record<SettingsCardType, React.ComponentType>> = {
	[SettingsCardType.AgentTemplates]: AgentTemplates,
	[SettingsCardType.Blitzes]: Blitzes,
	[SettingsCardType.CallAnalysis]: CallAnalysis,
	[SettingsCardType.Categories]: Categories,
	[SettingsCardType.DashAndReports]: ReportingContainer,
	[SettingsCardType.Gamification]: Gamification,
	[SettingsCardType.Goals]: Goals,
	[SettingsCardType.IssuesLog]: IssuesLog,
	[SettingsCardType.PhoneNumbers]: PhoneNumbers,
	[SettingsCardType.PrizesLog]: PrizesLog,
	[SettingsCardType.ScenarioManagement]: ScenarioManagement,
	[SettingsCardType.SlotMachinePrizes]: SlotMachinePrizes,
	[SettingsCardType.SlotMachines]: SlotMachines,
	[SettingsCardType.StartABlitz]: StartABlitz,
	[SettingsCardType.Utilities]: Utilities,
};

export const SettingsContainer = () => {
	const match = useRouteMatch<{ setting: SettingsCardType }>('/settings/:setting');
	const { account } = useUserSession();
	const setting = match?.params?.setting;
	const SettingPage = setting ? SettingPages[setting] : null;

	if (!setting || !SettingPage) {
		return <SettingsHome />;
	}

	const allowed = canOpenSetting(setting, {
		achievementsEnabled: !!account.features.aida.achievementsEnabled,
		allowUsersToSelectRule: !!account.features.aida.allowUsersToSelectRule,
		isAdmin: account.isAdmin,
		isLevitateSalesCoffeeAccount: account.isLevitateSalesCoffeeAccount,
	});

	return allowed ? <SettingPage /> : <Redirect to='/settings' />;
};
